import React, { ChangeEvent, RefObject, useEffect } from 'react';

import { useLocalStorage } from 'usehooks-ts';

import './PlaybackControl.scss';

type ControlsType = {
  videoRef: RefObject<HTMLVideoElement>;
  currentFileId?: string;
};
export const PlaybackControl = ({ videoRef, currentFileId }: ControlsType) => {
  const [playbackSpeed, setPlaybackSpeed] = useLocalStorage(
    'inspection:playbackSpeed',
    1,
  );

  // Apply the stored playback speed whenever the video element or file changes
  useEffect(() => {
    const videoElement = videoRef.current;

    if (!videoElement) return;

    const applyPlaybackSpeed = () => {
      // eslint-disable-next-line no-param-reassign
      videoElement.playbackRate = playbackSpeed;
    };

    videoElement.addEventListener('loadedmetadata', applyPlaybackSpeed);

    if (videoElement.readyState >= 1) {
      applyPlaybackSpeed();
    }

    return () => {
      videoElement.removeEventListener('loadedmetadata', applyPlaybackSpeed);
    };
  }, [currentFileId, playbackSpeed, videoRef]);

  const changePlaybackSpeed = (e: ChangeEvent<HTMLSelectElement>) => {
    const { target } = e;

    target.blur();
    setPlaybackSpeed(Number(target.value));
  };

  return (
    <select
      className="PlaybackControl"
      value={playbackSpeed}
      onChange={changePlaybackSpeed}
    >
      <option value={0.25}>0.25x</option>
      <option value={0.5}>0.50x</option>
      <option value={0.75}>0.75x</option>
      <option value={1}>1.00x</option>
      <option value={1.25}>1.25x</option>
      <option value={1.5}>1.50x</option>
      <option value={2}>2.00x</option>
    </select>
  );
};
